

import React, { useEffect, useState } from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaBars, FaTimes } from "react-icons/fa";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import logo from "../pages/modules/Component/maamaaslog.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from 'react-router-dom';
// import SliderComponent from '../pages/modules/Cloudkitchen/SliderComponent.js';
import SliderComponent from "../SliderComponent";
import {
  AppBar, Toolbar, Typography, Box, IconButton, Badge,
  Drawer, MenuItem, useMediaQuery, Paper
} from "@mui/material";


export default function Cloudnavbar({ showLogin, setShowLogin }) {

  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [scrolled, setScrolled] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [isForgot, setIsForgot] = useState(false);
  const [loginObj, setLoginObj] = useState({
    userName: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [hidePassword, setHidePassword] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  // const [showLogin, setShowLogin] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
  const [loginStepStarted, setLoginStepStarted] = useState(false);
  const [emailCheckMessage, setEmailCheckMessage] = useState("");
  const [loading, setLoading] = useState(false); // Added this line to fix the error
  const [cartCount, setCartCount] = useState(0);
  const [signupType, setSignupType] = useState("personal");

  const [termsAccepted, setTermsAccepted] = useState(false); // ✅ Track checkbox
  const [showContainer, setShowContainer] = useState(false);
  // State for drawer
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Add these useEffect hooks near your other useEffect hooks
  useEffect(() => {
    let timeoutId;
    if (showContainer) {
      // Auto close after 4 seconds
      timeoutId = setTimeout(() => {
        setShowContainer(false);
      }, 4000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [showContainer]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside the profile dropdown and profile icon
      const profileIcon = document.querySelector('[data-profile-icon]');
      const dropdown = document.querySelector('[data-profile-dropdown]');

      if (showContainer &&
        profileIcon &&
        dropdown &&
        !profileIcon.contains(event.target) &&
        !dropdown.contains(event.target)) {
        setShowContainer(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showContainer]);

  function handleSignInClick() {
    setShowLogin(true);
    // call your other function here if needed
    // someOtherFunction();
  }
  // Function for profile handling
  const handleProfile = () => {
    console.log("Profile button clicked");
    navigate("/profilepage");
  };
  const handleLogout = () => {
    // Remove login status from localStorage

    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("authToken"); // if you are storing token
    localStorage.removeItem("vendorId");  // optional, clear session data
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("userType");
    localStorage.removeItem("professionalUserId");
    localStorage.removeItem("role");
    localStorage.removeItem("userToken");

    // Update state
    setIsLoggedIn(false);
    setShowContainer(false);
    navigate("/");

    console.log("✅ Logged out successfully");
  };

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setShowMobileMenu(false);
      }
    };

    const handleScroll = () => setScrolled(window.scrollY > 50);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleChange = (e) => {
    setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    // ✅ Check if terms not accepted
    if (!termsAccepted) {
      setError("Please select Terms and Conditions");
      return;
    }

    setIsLoading(true);

    // Map signupType to backend expected enums
    const userType = signupType === "personal" ? "PERSONAL" : "PROFESSIONAL";

    const requestBody = {
      userName: loginObj.userName,
      emailId: loginObj.emailId,
      password: loginObj.password,
      referralCodeUsed: loginObj.referralCodeUsed || null, // ✅ always send null if empty
      mobileNumber: loginObj.mobileNumber,
      companyName: loginObj.companyName || null,
      role: "ROLE_USER",
      userType: userType, // PERSONAL / PROFESSIONAL
      termsAndConditions: termsAccepted, // ✅ send true if checked
    };

    console.log("📌 Signup Request Body:", requestBody);

    const apiUrl =
      "https://backend.maamaas.com/subscription/api/user/registration";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      console.log("📌 Response Status:", response.status);

      const result = await response.json().catch(() => ({}));
      console.log("📌 Response Body:", result);

      if (response.ok) {
        alert("Signup successful!");
        setIsSignup(false);
        setIsForgot(false);
      } else {
        setError(result.message || "Signup failed");
      }
    } catch (error) {
      console.error("❌ Error during signup:", error);
      setError("Something went wrong. Please try again.");
    }

    setIsLoading(false);
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setLoginObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // State
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      // ✅ Create URL with query parameters
      const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(
        loginObj.identifier
      )}&password=${encodeURIComponent(loginObj.password)}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          accept: "*/*",
        },
      });

      // ✅ Try to parse JSON safely
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("❌ Server did not return JSON:", text);
        throw new Error("Invalid JSON response from server");
      }

      console.log("🔹 Login API Response:", data);

      if (response.ok && data.token) {
        // ✅ Store both tokens and user details
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("userId", data.userId);
        localStorage.setItem("userType", data.userType || "");
        localStorage.setItem("professionalUserId", data.professionalUserId);
        localStorage.setItem("role", data.role);
        localStorage.setItem("isLoggedIn", "true");

        alert("Login successful!");
        setIsLoggedIn(true);
        setShowLogin(false);
        navigate("/homepage");
      } else {
        setError(data.message || "Login failed. Please try again.");
      }
    } catch (error) {
      console.error("❌ Login error:", error);
      setError("Email or Password wrong. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };
  // In your top-level component (Navbar, Header, etc.)
  useEffect(() => {
    const checkLogin = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      setIsLoggedIn(loggedIn);
    };

    checkLogin(); // run on mount

    window.addEventListener("storage", checkLogin); // sync across tabs/components

    return () => {
      window.removeEventListener("storage", checkLogin);
    };
  }, []);


  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) {
          setCartCount(0);
          return;
        }
        const response = await axios.get(
          `http://10.10.222.102:8080/IIA-3.4.3/api/cart/user/${userId}`
        );
        if (
          Array.isArray(response.data) &&
          response.data.length > 0 &&
          Array.isArray(response.data[0].items)
        ) {
          setCartCount(response.data[0].items.length);
        } else {
          setCartCount(0);
        }
      } catch (error) {
        console.error("Error fetching cart items:", error);
        setCartCount(0);
      }
    };
    fetchCartItems();
  }, []);


  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const getColoredText = (text) => {
    const words = text.split(" ");
    const half = Math.ceil(words.length / 2);
    return (
      <>
        <span style={{ color: "#FFD700" }}>{words.slice(0, half).join(" ")} </span>
        <span style={{ color: "white" }}>{words.slice(half).join(" ")}</span>
      </>
    );
  };



  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      // if page scrolled more than 50px, set true
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");





    try {
      const response = await axios.post(
        "https://backend.maamaas.com/food/api/user/forgot/password",
        {
          identifier: email, // backend expects `identifier`
        }
      );

      if (response.status === 200) {
        setMessage("Reset link sent successfully to your email.");
        setIsEmailSubmitted(true);
      } else {
        setMessage("Something went wrong. Please try again.");
      }
    } catch (error) {
      setMessage(
        error.response?.data?.message ||
        "Error while sending reset link. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };



  // Responsive styles
  const styles = {
    nav: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: 100,
      padding: isMobile ? "10px 16px" : "16px 32px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: scrolled ? "#b15cd6" : "transparent", // ✅ corrected
      color: "white",
      backdropFilter: scrolled ? "blur(8px)" : "none",
      boxShadow: scrolled ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
      transition: "all 0.4s ease",
      height: "65px",
    },
    logo: {
      display: "flex",
      alignItems: "center",
      fontSize: isMobile ? "20px" : "26px",
      fontWeight: "bold",
      color: "white",
      zIndex: 101,
    },
    logoText: {
      color: "white",
      fontSize: isMobile ? "16px" : "20px",
      textTransform: "uppercase",
    },
    logoTextOrange: {
      color: "orange",
      fontSize: isMobile ? "16px" : "20px",
      textTransform: "uppercase",
    },
    navRight: {
      display: isMobile ? (showMobileMenu ? "flex" : "none") : "flex",
      flexDirection: isMobile ? "row" : "row",
      alignItems: "center",
      justifyContent: "space-evenly",
      gap: isMobile ? "15px" : "20px",
      position: isMobile ? "fixed" : "relative",
      top: isMobile ? "65px" : "auto", // Changed from 70px to 65px
      left: 0,
      right: 0,
      backgroundColor: isMobile ? "#ffffffff" : "transparent",
      padding: isMobile ? "10px" : "0",
      width: isMobile ? "100%" : "auto",
      boxShadow: isMobile ? "0 5px 10px rgba(0,0,0,0.1)" : "none",
      zIndex: 100,
      borderRadius: "10px"
    },
    link: {
      textDecoration: "none",
      color: isMobile ? "#000000ff" : "white", // Black text on mobile, white on desktop
      fontSize: isMobile ? "18px" : "18px",
      fontWeight: "bold",
      cursor: "pointer",
      whiteSpace: "nowrap",
      padding: isMobile ? "8px 0" : "0",
      textTransform: "uppercase",
    },
    navLinks: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      gap: isMobile ? "15px" : "20px",
      marginRight: isMobile ? "0" : "20px",
    },

    iconWrapper: {
      borderRadius: "50%",
      padding: "8px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "36px",
      height: "36px",
      cursor: "pointer",
    },
    signInBtn: {
      padding: isMobile ? "8px 16px" : "10px 20px",
      backgroundColor: "orange",
      border: "none",
      borderRadius: "15px",
      color: "white",
      fontWeight: "600",
      cursor: "pointer",
      fontSize: isMobile ? "14px" : "16px",
      whiteSpace: "nowrap",
      textTransform: "uppercase",
    },
    mobileMenuButton: {
      display: isMobile ? "block" : "none",
      background: "none",
      border: "none",
      color: "white",
      fontSize: "24px",
      cursor: "pointer",
      zIndex: 102,
    },
    loginForm: {
      position: "fixed",
      top: isMobile ? "10px" : "20px",
      right: showLogin ? "0" : "-100%",
      width: "100%",
      maxWidth: isMobile ? "90%" : "400px",
      height: isMobile ? "90vh" : "70vh",
      backgroundColor: "white",
      borderRadius: "20px",
      padding: isMobile ? "20px 15px" : "40px 30px",
      boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
      transition: "right 0.5s ease-in-out",
      zIndex: 999,
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      overflowY: "auto",
    }


  };

  return (
    <>
      {/* Navbar */}
      <nav style={styles.nav}>
        <div style={styles.logo}>
          <Link
            to="/homepage"
            style={{
              ...styles.logo,
              textDecoration: "none", // ✅ remove underline
            }}
          >
            {/* <img
              src={logo}
              alt="Logo"
              style={{
                height: isMobile ? "40px" : "50px",
                marginRight: "10px",
              }}
            /> */}
            <div
              style={{
                fontSize: "32px",
                fontWeight: "bold",
                fontFamily: "'Poppins', sans-serif",
                display: "inline-block",
                margin: 0,
              }}
            >
              <span style={{ color: "white" }}>MAA</span>
              <span style={{ color: "white" }}>MAAS</span>
            </div>

          </Link>

        </div>

        <button style={styles.mobileMenuButton} onClick={toggleMobileMenu}>
          {showMobileMenu ? <FaTimes /> : <FaBars />}
        </button>

        <div style={styles.navRight}>
          <div style={styles.navLinks}>
            {/* <a href="/Speakerpage" target="_blank" rel="noopener noreferrer" style={styles.link}>PARTNERS</a> */}
            {/* <a href="/Trainerpage" target="_blank" rel="noopener noreferrer" style={styles.link}>MOVERS</a> */}
          </div>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {isLoggedIn ? (
              <>
                <IconButton
                  data-profile-icon
                  sx={{ color: isMobile ? "#000" : "inherit" }} // Change color for mobile
                  onClick={() => setShowContainer(!showContainer)}
                >
                  <AccountCircleIcon />
                </IconButton>
              </>
            ) : (
              <SliderComponent setShowLogin={setShowLogin} isMobile={isMobile} isLoggedIn={isLoggedIn} />
            )}
          </div>
        </div>


      </nav>

      {/* Login Form Popup */}
      <div style={styles.loginForm}>
        {/* Close Button */}
        <button
          style={{
            position: "absolute",
            top: "15px",
            right: "20px",
            fontSize: "28px",
            background: "none",
            border: "none",
            color: "#333",
            cursor: "pointer",
          }}
          onClick={() => {
            setShowLogin(false);
            setIsForgot(false);
            setIsSignup(false);
          }}
        >
          &times;
        </button>

        <p
          style={{
            marginBottom: 0,
            fontFamily: "revert",
            fontSize: isMobile ? "18px" : "22px",
            color: "#2a0947",
            fontWeight: "bold",
          }}
        >
          WELCOME TO MAAMAA'S
        </p>

        {/* Login Form */}
        {/* Login Form */}
        {!isSignup && !isForgot && (
          <>
            <form
              onSubmit={handleLogin}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <input
                type="text"
                placeholder="User ID"
                name="identifier"
                value={loginObj.identifier}
                onChange={handleChanges}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />

              <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={loginObj.password}
                  onChange={handleChanges}
                  style={{
                    padding: "10px",
                    paddingRight: "40px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#888"
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div style={{ textAlign: "right" }}>
                <span
                  onClick={() => setIsForgot(true)}   // 🔑 Ye toggle karega forgot form ko
                  style={{
                    color: "#007bff",
                    fontSize: "14px",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  Forget Password?
                </span>
              </div>
              {error && (
                <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
              )}
              <button
                type="submit"
                style={{
                  backgroundColor: "rgb(42 9 71)",
                  color: "white",
                  fontWeight: "bold",
                  padding: "12px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                disabled={isLoading}
              >
                {isLoading ? "Logging in..." : "LOGIN"}
              </button>
            </form>
          </>
        )}

        {/* Forgot Password Form */}
        {isForgot && !isEmailSubmitted && (
          <form onSubmit={handleSubmit}>
            <div>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                required
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  marginBottom: "10px",
                  width: "100%",
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                backgroundColor: "rgb(42 9 71)",
                color: "white",
                fontWeight: "bold",
                padding: "12px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                width: "100%",
              }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Submit"}
            </button>

            {/* Back to login link */}
            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <span
                onClick={() => setIsForgot(false)}   // 🔙 Isse wapas login dikhega
                style={{
                  color: "#007bff",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Back to Login
              </span>
            </div>
          </form>
        )}

        {/* Success/Error Message */}
        {message && (
          <div
            style={{
              marginTop: "15px",
              padding: "10px",
              borderRadius: "6px",
              textAlign: "center",
              color: message.includes("successfully") ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {message}
          </div>
        )}


        {/* Signup Form */}
        {isSignup && (
          <>
            {/* Signup Type Selector */}
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              <label>
                <input
                  type="radio"
                  name="signupType"
                  value="personal"
                  checked={signupType === "personal"}
                  onChange={() => setSignupType("personal")}
                />{" "}
                Personal
              </label>
              <label>
                <input
                  type="radio"
                  name="signupType"
                  value="professional"
                  checked={signupType === "professional"}
                  onChange={() => setSignupType("professional")}
                />{" "}
                Professional
              </label>
            </div>

            <form
              onSubmit={handleSignup}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <input
                type="text"
                name="userName"
                placeholder="Name"
                value={loginObj.userName}
                onChange={handleChange}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
              <input
                type="email"
                name="emailId"
                placeholder="Email"
                value={loginObj.emailId}
                onChange={handleChange}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
              <input
                type="text"
                name="mobileNumber"
                placeholder="Phone Number"
                value={loginObj.mobileNumber}
                onChange={handleChange}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />

              {/* Show companyName only for Professional */}
              {signupType === "professional" && (
                <input
                  type="text"
                  name="companyName"
                  placeholder="Company Name"
                  value={loginObj.companyName}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
              )}

              {/* Password Field */}
              <div
                style={{ position: "relative", display: "inline-block", width: "100%", marginBottom: "15px" }}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Create Password"
                  value={loginObj.password}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#888",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* Referral Code Field */}
              <div style={{ width: "100%", marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#444",
                    marginBottom: "6px",
                  }}
                >
                  🎁 Have a Referral Code?
                </label>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type="text"
                    name="referralCode"
                    placeholder="Enter your referral code "
                    value={loginObj.referralCodeUsed}
                    onChange={handleChange}
                    style={{
                      padding: "12px 40px 12px 12px",
                      fontSize: "16px",
                      border: "2px dashed #7c3aed", // dashed border highlight
                      borderRadius: "8px",
                      width: "100%",
                      boxSizing: "border-box",
                      backgroundColor: "#f9f5ff", // light purple background
                      fontWeight: "500",
                      color: "#111",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "12px",
                      transform: "translateY(-50%)",
                      fontSize: "18px",
                      color: "#7c3aed",
                      fontWeight: "bold",
                    }}
                  >
                    %
                  </span>
                </div>
                <small style={{ color: "#6b7280", fontSize: "12px" }}>
                  Apply referral code & unlock exciting rewards!
                </small>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "6px",
                  fontSize: "14px",
                  lineHeight: "20px",
                }}
              >
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <span>I hereby agree to the</span>
                <a
                  href="/Termscondition"

                  rel="noopener noreferrer"
                  style={{ color: "#007bff", textDecoration: "none" }}
                >
                  Terms & Conditions
                </a>
                <span>and</span>
                <a
                  href="/gaming"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007bff", textDecoration: "none" }}
                >
                  Privacy Policy
                </a>
                <span>of Maamaas</span>
              </div>

              <button
                type="submit"
                disabled={!termsAccepted || isLoading}
                style={{
                  backgroundColor: !termsAccepted ? "gray" : "rgb(42 9 71)",
                  color: "white",
                  fontWeight: "bold",
                  padding: "12px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: !termsAccepted ? "not-allowed" : "pointer",
                }}
              >
                {isLoading ? "Signing up..." : "SIGN UP"}
              </button>

              {error && (
                <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
              )}
            </form>

          </>
        )}

        {/* Switch Between Login & Signup */}
        {!isForgot && (
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: "14px" }}>
              {isSignup
                ? "Already have an account?"
                : "Don't have an account?"}{" "}
              <span
                onClick={() => {
                  setIsSignup(!isSignup);
                  setIsForgot(false);
                }}
                style={{
                  color: "rgb(42 9 71)",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                {isSignup ? "Login here" : "Sign up"}
              </span>
            </p>

          </div>
        )}
      </div>

      {showContainer && (
        <Paper
          data-profile-dropdown // Add this data attribute
          sx={{
            position: "fixed",
            top: "60px",
            right: "10px",
            width: "120px",
            backgroundColor: "white",
            boxShadow: 3,
            borderRadius: "8px",
            zIndex: 1000,
            animation: "fadeIn 0.2s ease-in", // Optional: Add fade-in animation
          }}
        >
          {/* <MenuItem
            onClick={handleProfile}
            sx={{ fontSize: "14px", padding: "8px 16px" }}
          >
            Profile
          </MenuItem> */}
          <MenuItem
            onClick={handleLogout}
            sx={{ fontSize: "14px", padding: "8px 16px" }}
          >
            Logout
          </MenuItem>
        </Paper>
      )}


    </>
  );
}